import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { connect } from 'react-redux';
import { productionBatchStatistics } from '@reducers/statistics';
import { getNCFileById } from '@reducers/manufacture';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { NCFileSearchItem } from '@interfaces/search';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { View } from 'react-native';
import { DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

interface BatchDetailsNCFileDocumentsProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const BatchDetailsNCFileDocumentsComponent: FC<BatchDetailsNCFileDocumentsProps> = ({
  getNCFileById,
  clearTools,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
  ncFileData,
}) => {
  const title = useTitle();

  useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      {ncFileData?.data?.ncFileId && (
        <View style={DETAILS_DOCUMENTS_SCREENS_CONTAINER_STYLES}>
          <ImagesDocumentsContent documentRetrieveId={ncFileData.data.ncFileId} documentRetrieveKey={DOCUMENT_ENTITY_TYPE.NcFile} />
        </View>
      )}
    </DetailsPageWrapper>
  );
};

const BatchDetailsNCFileDocuments = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  getNCFileById,
  clearTools,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
})(BatchDetailsNCFileDocumentsComponent);

export { BatchDetailsNCFileDocuments };
